





























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ResourceListItemDTO } from '@bookings/interfaces/online-bookings';

@Component({
  name: 'bpc-resource-selector',
  components: {},
})
export default class ResourceSelector extends Vue {
  @Prop(Object) readonly value: ResourceListItemDTO;
  @Prop(Array) readonly resources: ResourceListItemDTO[];
  @Prop(Boolean) readonly loading: boolean;

  get model() {
    return this.value;
  }

  set model(value: ResourceListItemDTO) {
    this.$emit('input', value);
  }

  get showMore(): boolean {
    return (
      this.model &&
      (!!this.model.infoDimensions ||
        !!this.model.infoCapacity ||
        !!this.model.infoFloor ||
        !!this.model.infoMiscellaneous)
    );
  }

  showMoreInfoId = null;

  toggleShowMoreInfo(resource: ResourceListItemDTO) {
    this.model = null;
    this.showMoreInfoId = this.showMoreInfoId === resource.id ? null : resource.id;
  }
  selectResource(resource: ResourceListItemDTO) {
    this.showMoreInfoId = resource.id;
    this.model = resource;
    this.$emit('resource-selected', resource);
  }
}
